import { render, staticRenderFns } from "./Categorie.vue?vue&type=template&id=4c6231bc&"
import script from "./Categorie.vue?vue&type=script&lang=js&"
export * from "./Categorie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports